// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/altitude-types.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/altitude-types/altitude-types.js';

mount([g0]);
